module.exports = __webpack_public_path__ + "img/feature_buy_zh.70acd19e.png";